export function formatCourseId(courseId) {
    if (!courseId || typeof courseId !== 'string') return courseId;
    return courseId.replace(/[_-]+/g, ' ').trim();
}

export function formatCourseName(course) {
    if (!course) return '';
    if (typeof course === 'string') return formatCourseId(course);
    const name = course.name || '';
    return name ? formatCourseId(name) : '';
} 